import React, { Component } from 'react';
import {Route} from "react-router-dom";
import {ACCESS_TOKEN, V1_API_URL_PREFIX} from "../../Constants";
import {NotificationManager} from "react-notifications";
import { t } from '../../i18n';

class Admin extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fileNames: [],
            message: null
        };
    }

    submit() {
        let companyname = document.getElementById("companyname");
        if (
            companyname && companyname.value !== ''
        ) {
            const headers = new Headers({
                'Content-Type': 'application/json',
            });

            if (localStorage.getItem(ACCESS_TOKEN)) {
                headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
            }

            const defaults = {headers: headers};
            let options = Object.assign({}, defaults, {
                url: V1_API_URL_PREFIX + "/admin/delete-client",
                method: 'POST',
                body: companyname.value
            });
            return fetch(options.url, options)
                .then(response => {
                        if (response.status !== 200) {
                            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
                            return Promise.reject();
                        }
                        document.getElementById("companyname").value = "";
                        NotificationManager.success(t('app.notifications.success'), t('messages.clientDeactivated'), 5000);
                        return Promise.resolve();
                    }
                );
        } else {
            console.log("invalid");
            NotificationManager.error(t('app.notifications.error'), t('messages.validationErrorFields'), 5000);
        }
    }

    render() {
        return (
            <Route path={`/admin/delete-client` }>
            <div className="container" style={{ textAlign: "center" }}>
                <h3>{ t('admin.deleteClient.title') }</h3>
                <div className="container">
                    <table className="table" style={{ marginLeft: "auto", marginRight: "auto" }}>
                        <tbody style={{ textAlign: "right"}}>
                        <tr>
                            <td>{ t('admin.deleteClient.companyNameLabel') } <span style={{ color: "red" }}>*</span></td>
                            <td><input type="text" name="companyname" id="companyname"/></td>
                        </tr>
                        <tr style={{ textAlign: "left"}}>
                            <td></td>
                            <td><button type="submit" onClick={ this.submit }>{ t('admin.deleteClient.deleteButton') }</button></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            </Route>
        )
    }
}

export default Admin;